/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

import { appConfigSelector } from 'reducers/app.reducer';
import { ICustomTheme } from 'interfaces';
import {
  StyledContainer,
  StyledDeliveryAndSalesChild,
  StyledDeliveryAndSalesContainer,
  StyledDeliveryIcon,
  StyledCallIcon,
  StyledProgramHours,
  StyledProgramHoursContainer,
  StyledTypography,
} from './styles';

export const StoreFooter: React.FC = () => {
  const { t } = useTranslation();
  const theme: ICustomTheme = useTheme();
  const { programHours } = useSelector(appConfigSelector);
  const isDesktop = !useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <StyledContainer isDesktop={isDesktop}>
      <StyledProgramHoursContainer isDesktop={isDesktop}>
        <StyledProgramHours isDesktop={isDesktop}>
          {programHours}
        </StyledProgramHours>
      </StyledProgramHoursContainer>
      <StyledDeliveryAndSalesContainer>
        <StyledDeliveryAndSalesChild>
          <StyledDeliveryIcon isDesktop={isDesktop} />
          <StyledTypography isDesktop={isDesktop}>
            <strong>{t('footer.delivery_duration')}</strong>
          </StyledTypography>
          <StyledTypography isDesktop={isDesktop}>
            {t('footer.average_time')}
          </StyledTypography>
        </StyledDeliveryAndSalesChild>
        <StyledDeliveryAndSalesChild>
          <StyledCallIcon isDesktop={isDesktop} />
          <StyledTypography isDesktop={isDesktop}>
            <strong>{t('footer.afterSalesServices')}</strong>
          </StyledTypography>
          <StyledTypography isDesktop={isDesktop}>
            {t('footer.afterSalesServicesPrecisions')}
          </StyledTypography>
        </StyledDeliveryAndSalesChild>
      </StyledDeliveryAndSalesContainer>
    </StyledContainer>
  );
};

export default StoreFooter;
